module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pr header_web"
  }, [_c('div', {
    staticClass: "w1200 m0"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_c('img', {
    staticClass: "mr10",
    attrs: {
      "src": "/static/images/jplogo.png",
      "width": "50"
    }
  }), _vm._v(_vm._s(_vm.platName))])]), _vm._v(" "), _c('ul', {
    staticClass: "pa header-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0729e742"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Top.vue
// module id = 1128
// module chunks = 41